import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue-demi';
import { provideFormsConfig } from './composables/useFormsConfig';
import { useLocalization } from './composables/useLocalization';
import { createFormsApi } from '../api/formsApi';

interface Props {
  baseUrl?: string;
  recaptcha?: {
    siteKey?: string;
    theme?: 'light' | 'dark';
    size?: 'normal' | 'compact';
  };
  locale?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FormsProvider',
  props: {
    baseUrl: null,
    recaptcha: null,
    locale: null
  },
  setup(__props: any) {

const props = __props as {
  baseUrl?: string;
  recaptcha?: {
    siteKey?: string;
    theme?: 'light' | 'dark';
    size?: 'normal' | 'compact';
  };
  locale?: string;
};


const formsApi = createFormsApi({ baseUrl: props.baseUrl });

const { setLocale } = useLocalization();

const config = computed(() => ({
  baseUrl: props.baseUrl,
  recaptcha: props.recaptcha,
  locale: props.locale,
  formsApi,
}));

watch(
  () => props.locale,
  (value) => {
    if (value) {
      setLocale(value);
    }
  },
  { immediate: true },
);

provideFormsConfig(config);

return { __sfc: true,props, formsApi, setLocale, config }
}

})